import { useDispatch, useSelector } from "react-redux"
import {
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_PAGEACTION_TYPE, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    NextUITable,
} from "../../components"
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    useDisclosure,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faEdit,
    faPlus,
    faReceipt,
    faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
    COLUMN_ALIGN_TYPE,
    COLUMN_TYPE,
    FOOTER_TYPE,
    ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import {
    setIsCreditNote,
    setNewEntryMode,
    setDetailParams,
    resetDetailParams,
} from "../../state/creditDebitNoteSlice"
import ReportViewer from "../report/ReportViewer"
import { enum_Report_Type } from "../report/ReportUtility"
import { resetReportData, resetReportDetail, setInvoiceDetail } from "../../state/invoiceEntrySlice"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"

const CreditDebitNoteMaster = () => {
    let disapatch = useDispatch()
    let navigate = useNavigate()
    const { token, user } = useSelector((state) => state.auth)
    const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
    let [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")
    //let [data, setData] = useState([])

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        disapatch(resetDetailParams())
    }, [])

    const {
        isOpen: isOpenReportModel,
        onOpen: onOpenReportModel,
        onOpenChange: onOpenReportModelChange,
    } = useDisclosure()

    const {
        isError,
        isPending,
        data = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.creditDebitNote.fetchEntry,
        queryKey: "Credit Invoice Data List",

    })
    //console.log(GetLoginCredentialDb())
    const funFilterData = () => {
        filterData({
            data: {
                compcode: compCode.join(","),
                db_user: GetLoginCredentialDb(user, yearId)
            }
        })
    }

    useEffect(() => {
        funFilterData();
    }, [])


    const onSuccessDelete = (data) => {
        setItemToDelete("")
        toast.success("deleted successfully", {
            position: "top-center"
        })
        funFilterData();
    }

    const { mutate: FndeleteNote } = usePost(
        {
            url: apiRoute.creditDebitNote.deleteEntry,
            query: "delete-note",
            onSuccessTasks: onSuccessDelete
        }
    )

    let totalAmt = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "NetAmt",
            }),
        [data]
    )

    const INITIAL_VISIBLE_COLUMNS = [
        "actions",
        "Party",
        "Bill_No",
        "NetAmt",
        "Bill_Date",
        "Account",

    ]

    const exportColumns = [
        {
            name: "PARTY NAME",
            uid: "Party",
        },
        {
            name: "BILL NO",
            uid: "Bill_No",
        },
        {
            name: "AMOUNT",
            uid: "NetAmt",
        },
        {
            name: "DATE",
            uid: "Bill_Date",
            type: COLUMN_TYPE.date
        },
        {
            name: "ACCOUNT",
            uid: "Account",
        },
    ]

    let downloadDataFooter = {
        Party: "",
        Bill_No: "",
        NetAmt: "Total: " + totalAmt,
        Bill_Date: "",
        Account: "",
    }

    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }

    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "PARTY NAME",
            uid: "Party",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "BILL NO",
            uid: "Bill_No",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "AMOUNT",
            uid: "NetAmt",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalAmt,
            },
        },
        {
            name: "DATE",
            uid: "Bill_Date",
            type: COLUMN_TYPE.date,
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
        },
        {
            name: "ACCOUNT",
            uid: "Account",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
        },
    ]

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete != "" && itemToDelete != null && Object.keys(itemToDelete).length > 0) {
                FndeleteNote({
                    data: {
                        transaction_id: itemToDelete.transaction_id,
                        comp_code: itemToDelete.comp_code,
                    }
                })
            }
            else if (itemToEdit != "" && itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                disapatch(setDetailParams(itemToEdit))
                disapatch(setIsCreditNote(true))
                disapatch(setNewEntryMode(false))
                navigate(linksUrl.creditDebitEntry.createEntry)
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }
        // if (data) {
        //     FndeleteNote({
        //         data: {
        //             transaction_id: itemToDelete.transaction_id,
        //             comp_code: itemToDelete.comp_code,
        //         }
        //     })
        // }
        // else {
        //     setItemToDelete("")
        // }

    }

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    comp_code: row.CompCode,
                    transaction_id: row.TransactionId,
                }
                setItemToEdit(obj)
                // disapatch(setDetailParams(obj))
                // disapatch(setIsCreditNote(true))
                // disapatch(setNewEntryMode(false))
                // navigate(linksUrl.creditDebitEntry.createEntry)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.CompCode })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#0a4da6" icon={faReceipt} />,
            onClick: (row) => {
                let obj = {
                    token: token,
                    comp_code: row.CompCode,
                    trans_id:row.TransactionId,
                    trade_of: 'G',
                    bill_type: "V",
                    db_user: GetLoginCredentialDb(user, yearId)
                }
                disapatch(resetReportData())
                disapatch(setInvoiceDetail(obj))
                onOpenReportModel()
            },
            label: "print",
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ]

    const handleAddNew = () => {
        disapatch(resetDetailParams())
        navigate(linksUrl.creditDebitEntry.createEntry)
    }

    const reportModel = () => {
        return (
            <div>
                <Modal
                    isOpen={isOpenReportModel}
                    onOpenChange={onOpenReportModelChange}
                    size="xl"
                    placement="center"
                >
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalHeader className="flex flex-row gap-1">
                                    Credit / Debit Note
                                </ModalHeader>
                                <ModalBody className="overflow-auto ">
                                    <div className="flex flex-col">
                                        <ReportViewer props_ReportType={enum_Report_Type.DBCRNote} />
                                    </div>
                                </ModalBody>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            </div>
        )
    }

    return (
        <div>
            {reportModel()}
            {itemToDelete != "" || itemToEdit != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} actionType={pageActionType} /> : ""}

            <MainContainer
                pageName="Credit/Debit Note"
                info={[]}
                breadcrumbs={["Account", "Credit Debit Note"]}
            >
                <div className="" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onClick={handleAddNew}
                    >
                        Add New
                    </Button>
                </div>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    // handleDataChange={handleDataChange}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="CreditDebitNote-List"
                    showAdvanceFilter={false}
                    id="TransactionId"
                ></NextUITable>
            </MainContainer>
        </div>
    )
}
export default CreditDebitNoteMaster
